import { ptBrCommonFieldsTranslations } from "../common";

export const conversation = {
  name: "Conversa |||| Conversas",
  fields: {
    subject: "Assunto",
    status: "Status",
    source: "Origem",
    channel: "Canal",
    contact: "Contato",
    lastMessage: "Última mensagem",
    lastMessageAt: "Última mensagem em",
    lastActivityAt: "Última atividade",
    phoneNumber: "Número de Telefone",
    contactName: "Nome do Contato",
    instagramUserId: "ID do Usuário Instagram",
    selectContact: "Selecionar Contato",
    createdAt: ptBrCommonFieldsTranslations.createdAt,
    updatedAt: ptBrCommonFieldsTranslations.updatedAt,
  },
  tabs: {
    chat: "Chat",
    details: "Detalhes",
  },
  actions: {
    viewConversation: "Ver conversa",
    create: "Iniciar conversa",
  },
  dialogs: {
    create: {
      title: "Iniciar conversa",
      subtitle: "Escolha o tipo de conversa que deseja iniciar",
      selectType: "Tipo de Conversa",
      channel: "Canal",
      channelHelper: "WhatsApp, Instagram, etc.",
    },
  },
  channelTypes: {
    zapy: "Zapy (WhatsApp)",
    zapyHelper: "Inicie uma conversa pelo WhatsApp. Digite o número no formato internacional.",
    telegram: "Telegram",
    telegramHelper: "Telegram não permite iniciar conversas. Somente contatos que já enviaram mensagem para o bot podem ser selecionados.",
    whatsappOfficial: "WhatsApp Oficial",
    whatsappOfficialHelper: "Inicie uma conversa pelo WhatsApp. Digite o número no formato internacional.",
    instagram: "Instagram",
    instagramHelper: "Inicie uma conversa por DM do Instagram. Digite o ID do usuário.",
    webchat: "Webchat",
    webchatHelper: "Crie uma conversa por webchat. Opcionalmente forneça o nome do contato.",
  },
  zapy: {
    searching: "Buscando contato...",
    newContact: "Nenhum contato encontrado para este número. Você pode fornecer um nome para o novo contato.",
    nameHelper: "Opcional. Um nome para identificar este contato.",
  },
  telegram: {
    noContacts: "Nenhum contato encontrado. Somente usuários que já enviaram mensagem para este bot podem receber tickets.",
    noMatchingContacts: "Nenhum contato correspondente encontrado",
  },
  helpers: {
    phoneNumber: "Formato internacional: +5511999999999",
    contactName: "Nome para exibir para este contato",
    instagramUserId: "O ID único do usuário no Instagram",
    selectContact: "Selecione um contato existente para iniciar a conversa",
    telegramContact: "Busque por nome do contato que já iniciou conversa com o bot",
  },
  inputMode: {
    phone: "Novo Número",
    contact: "Contato Existente",
  },
  errors: {
    noConnectionAvailable: "Nenhuma conexão disponível para este canal. Configure uma conexão antes de iniciar uma conversa.",
    noConnection: "Sem conexão",
    noContact: "Selecione um contato para criar o ticket",
    unsupportedChannel: "Tipo de canal não suportado para criação de tickets",
  },
  noActiveConnection: "Nenhuma conexão ativa encontrada para este canal. Verifique se o WhatsApp está conectado.",
  noContacts: "Nenhum contato encontrado. Você pode digitar um novo número de telefone.",
  empty: "Nenhuma conversa",
  noSearchResults: "Nenhuma conversa encontrada",
  search: "Buscar conversas...",
  info: "Informações da conversa",
  source: "Origem",
  createdAt: "Criada em",
  crossTenant: "Cross-Tenant",
  sources: {
    inbound: "Recebida",
    outbound: "Enviada",
  },
  participantRole: {
    owner: "Proprietário",
    participant: "Participante",
    admin: "Administrador",
    agent: "Atendente",
  },
};

export const conversations = {
  name: "Conversas",
  tabs: {
    all: "Todos",
    mine: "Minhas",
    unassigned: "Sem atribuição",
  },
  filters: {
    search: "Buscar conversas...",
    advanced: "Filtros Avançados",
    status: "Status",
    priority: "Prioridade",
    queue: "Fila",
    channel: "Canal",
    assignment: "Atribuição",
    assignmentAll: "Todas",
    assignmentMine: "Atribuídas a mim",
    assignmentUnassigned: "Sem atribuição",
  },
  sort: {
    lastActivity: "Última atividade",
    createdDate: "Data de criação",
  },
  createConversation: "Nova conversa",
  empty: {
    title: "Nenhuma conversa",
    subtitle: "Inicie uma nova conversa para começar",
  },
  details: {
    title: "Detalhes",
    userInfo: "Informações do Usuário",
    contactInfo: "Informações do Contato",
    ticketInfo: "Informações do Ticket",
    conversationInfo: "Informações da Conversa",
    noTicket: "Nenhum ticket ativo",
    quickActions: "Ações Rápidas",
  },
};
